/**
 * Fill classes per coverage status, shared by cells, legend swatches and the
 * detail panel dot. 'citable' stays in the citation-gold family of
 * status-progress ("still verifying sources", visual-identity.md §2.3) with a
 * DASHED border: cited text whose structure is not validated yet must never
 * read as the full navy of a validated hierarchy — the visual half of the tier
 * honesty rule (ADR-0023). No new color token.
 *
 * Two adjustments came with ADR-0035. `citable` was so pale it read as OFF,
 * which is the misreading the whole decision exists to fix: it is a POSITIVE
 * state — the text is loaded and every citation resolves to its page — so its
 * fill is raised to match `progress`. And `partial` sits between the two, in
 * the accent family with a dashed border: part of the province navigates by
 * axis and part does not, and the ramp has to read pending → citable → partial
 * → covered without inventing a fifth colour.
 */

import type { MapStatus } from './types';

export const STATUS_FILL: Record<MapStatus, string> = {
  covered: 'bg-accent text-accent-contrast border-accent hover:bg-accent/90',
  progress:
    'bg-status-progress/25 text-ink border-status-progress/50 hover:bg-status-progress/35',
  partial: 'bg-accent/30 text-ink border-dashed border-accent hover:bg-accent/40',
  citable:
    'bg-status-progress/25 text-ink border-dashed border-status-progress/70 hover:bg-status-progress/35',
  pending:
    'bg-paper-tinted text-ink-muted border-line hover:bg-paper-tinted/80 hover:border-line_strong',
};

export const SWATCH_FILL: Record<MapStatus, string> = {
  covered: 'bg-accent border-accent',
  progress: 'bg-status-progress/25 border-status-progress/50',
  partial: 'bg-accent/30 border-dashed border-accent',
  citable: 'bg-status-progress/25 border-dashed border-status-progress/70',
  pending: 'bg-paper-tinted border-line',
};

export const DOT_FILL: Record<MapStatus, string> = {
  covered: 'bg-accent',
  progress: 'bg-status-progress',
  partial: 'bg-accent',
  citable: 'bg-status-progress',
  pending: 'bg-status-pending',
};
